module.exports = __webpack_public_path__ + "static/media/la-times.142b20ab.jpg";